import { Avatar, Card, CardActionArea, CardContent, CardMedia, Typography, } from "@mui/material";

import { Link } from "react-router-dom";


import { Product } from "../../app/models/product";
import { currencyFormat } from "../../app/util/util";

interface Props {
  product: Product
}


export default function ProductCard({product}: Props) {
  
  return (
    
    <Card>
    <CardActionArea component={Link} to={`/catalog/${product.id}`}>
        {product.quantityInStock===0 && 
            <Avatar alt="sold" src="/images/sold.png" sx={{float: "left", width: 56, height: 56}}/>
        }
        <CardMedia
          sx={{ height: 300, backgroundSize: 'contain', bgcolor: 'white' }}
          image={product.pictureUrl}
          title={product.name}
        />
      
        <CardContent>
            <Typography variant="h6" gutterBottom>
                {currencyFormat(product.price)} NZD
            </Typography>
            <Typography variant="body1" gutterBottom>
                {product.name}
            </Typography>
            <Typography variant="body2" color="text.secondary">
                {product.category}
            </Typography>
        </CardContent>
    </CardActionArea>
    </Card>

     
  )
}

/* <Card>
<CardActionArea component={Link} to={`/catalog/${product.id}`}>
    {product.quantityInStock===0 && 
        <Avatar alt="sold" src="/images/sold.png" sx={{float: "left", width: 56, height: 56}}/>
    }
    <CardMedia
      sx={{ height: 300, backgroundSize: 'contain', bgcolor: 'white' }}
      image={product.pictureUrl}
      title={product.name}
    />
  
    <CardContent>
        <Typography variant="h6" gutterBottom>
            {currencyFormat(product.price)}
        </Typography>
        <Typography variant="body1" gutterBottom>
            {product.name}
        </Typography>
        <Typography variant="body2" color="text.secondary">
            {product.category}
        </Typography>
    </CardContent>
</CardActionArea>
</Card> */